import { Box, Card, CardContent, CardMedia, Toolbar, Typography } from '@mui/material'
import React from 'react'

export default function ProjectCard({ img, title, details }) {
    let detailData = String(details).split("<br/>");
    return (

        <Card sx={{ display: 'block' }} elevation={0} sx={{ padding: 2, maxHeight: { xl: "30vh" } }}>
            <CardMedia
                component="img"
                sx={{ width: "300px", height: "150px", objectFit: "contain" }}
                image={img}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', top:"-10%", position:'relative' }}>
                <CardContent sx={{ flex: '1 0 auto', textAlign: "left" }}>
                    <Typography component="h6" variant="h6">
                        {title}
                    </Typography>
                    <br />
                    <Typography variant="subtitle1" color="text.secondary" component="div">
                        {detailData.map((value, index) => {
                            { return (<React.Fragment>{value} <br /></React.Fragment>) }

                        })}
                    </Typography>
                </CardContent>
            </Box>
        </Card>)
}
